/**
 * branch.io script for deep links to app.
 */

import Script from 'next/script';
import { useIsMobile } from '@stores/AppCommonData';

const renderBranchSnippet = `
  // load Branch.io for app deeplinking
  (function (b, r, a, n, c, h, _, s, d, k) {
    if (!b[n] || !b[n]._q) {
      for (; s < _.length; ) c(h, _[s++]);
      d = r.createElement(a);
      d.async = 1;
      d.src = 'https://cdn.branch.io/branch-latest.min.js';
      k = r.getElementsByTagName(a)[0];
      k.parentNode.insertBefore(d, k);
      b[n] = h;
    }
  })(window, document, 'script', 'branch', function(){}, {}, ''.split(' '), 0);
`;

const BranchDeepLinksScript = () => {
  const isMobile = useIsMobile();

  return isMobile ? (
    <Script
      strategy="afterInteractive"
      id="branchio-script"
      dangerouslySetInnerHTML={{ __html: renderBranchSnippet }}
    />
  ) : null;
};

export default BranchDeepLinksScript;
